/**
 * Anti-clickjacking and iframe detection.
 */

export function initSecurityChecks() {
  if (typeof window === "undefined") return;

  // Check if app is loaded in an iframe
  if (isInIframe()) {
    preventClickjacking();
  }

  // Monitor DOM for iframe injection attempts
  const observer = new MutationObserver(() => {
    if (isInIframe()) {
      preventClickjacking();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true; // Cross-origin iframe
  }
}

function preventClickjacking(): void {
  if (!window.top) return;
  try {
    // Break out of iframe. A cross-origin parent blocks this navigation with a
    // SecurityError (e.g. the legitimate /embed/iframe route framed by a third
    // party); it can never succeed there, so swallow it. Real frame protection
    // is the server's Content-Security-Policy frame-ancestors, not this.
    window.top.location.href = window.self.location.href;
  } catch {
    // Cross-origin frame — navigation not permitted, nothing to do.
  }
}
